import { checkIsInternalCompany } from 'app/auth/authUtils';
import _ from 'lodash';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getIsFromInternalCompany } from 'store/auth/selectors';
import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectSellerAdjustmentTypes = createSelector(
  getSystem,
  ({ sellerAdjustmentTypes }) => sellerAdjustmentTypes,
);

const selectSellerAdjustmentTypesValues = createSelector(
  [selectSellerAdjustmentTypes, getIsFromInternalCompany],
  (sellerAdjustmentTypes, isInternalCompany) =>
    _.sortBy(sellerAdjustmentTypes, [({ name }) => _.toLower(name)]).map(sellerAdjustmentType => ({
      ...sellerAdjustmentType,
      isGlobal: !isInternalCompany && checkIsInternalCompany(sellerAdjustmentType),
    })),
);

export const selectSellerAdjustmentTypesOptions = createSelector(
  selectSellerAdjustmentTypesValues,
  sellerAdjustmentTypes =>
    sellerAdjustmentTypes.map(({ sellerAdjustmentTypeId, name, isDeleted }) => ({
      name,
      value: sellerAdjustmentTypeId,
      isDeleted,
    })),
);

export const selectFilteredSellerAdjustmentTypes = createSelector(
  getDebouncedSearchValue,
  selectSellerAdjustmentTypesValues,
  searchItems(sellerAdjustmentType => [sellerAdjustmentType.name]),
);
